
import { MapTo } from '@adobe/aem-react-editable-components';
import MitekFlow, { MitekFlowEditConfig } from './MitekFlow';

export default MapTo('cob-corp-acquisition/components/creditonebank/mitek-flow')(MitekFlow, MitekFlowEditConfig);
        